/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type userGeoInfo_regionalInfo$ref = any;
export type userGeoInfo_regionalInfo = {
    readonly zipCode: string | null;
    readonly incomeLevel: {
        readonly incomeBracket: string | null;
        readonly incomePercentile: string | null;
    } | null;
    readonly " $refType": userGeoInfo_regionalInfo$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "userGeoInfo_regionalInfo",
    "type": "RegionalInfo",
    "metadata": null,
    "argumentDefinitions": [
        {
            "kind": "RootArgument",
            "name": "zipCode",
            "type": "String"
        }
    ],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": null,
            "name": "zipCode",
            "args": null,
            "storageKey": null
        },
        {
            "kind": "LinkedField",
            "alias": null,
            "name": "incomeLevel",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "zipCode",
                    "variableName": "zipCode"
                }
            ],
            "concreteType": "IncomeLevel",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "incomeBracket",
                    "args": null,
                    "storageKey": null
                },
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "incomePercentile",
                    "args": null,
                    "storageKey": null
                }
            ]
        }
    ]
} as any);
(node as any).hash = '75f108bf49afac56bb3cfbf4fc90cbe9';
export default node;
